(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["envio-2020home"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('envio-2020home')) return;

    const STORAGE_KEY = 'envio2020home:destino';
    const LOCATIONS_KEY = 'envio2020home:locations';
    const COP = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });

    const read = (storage, key) => {
      try { return JSON.parse(storage.getItem(key) || 'null'); } catch (e) { return null; }
    };
    const write = (storage, key, value) => {
      try { storage.setItem(key, JSON.stringify(value)); } catch (e) { /* almacenamiento bloqueado */ }
    };
    const titleCase = (s) => s.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());
    const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    let locationsPromise = null;
    function loadLocations(endpoint) {
      const cached = read(sessionStorage, LOCATIONS_KEY);
      if (cached) return Promise.resolve(cached);
      locationsPromise ||= fetch(`${endpoint}/api/shipping/locations`)
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((data) => { write(sessionStorage, LOCATIONS_KEY, data); return data; })
        .catch((e) => { locationsPromise = null; throw e; });
      return locationsPromise;
    }

    class Envio2020Home extends HTMLElement {
      connectedCallback() {
        this.endpoint = this.dataset.endpoint;
        this.seq = 0; // solo vale la respuesta del último cálculo
        this.dept = this.querySelector('[data-envio-dept]');
        this.city = this.querySelector('[data-envio-city]');
        this.result = this.querySelector('[data-envio-result]');

        this.dept.addEventListener('change', () => { this.fillCities(); this.save(); this.quote(); });
        this.city.addEventListener('change', () => { this.save(); this.quote(); });
        this.onCartUpdate = () => this.quote();
        document.addEventListener('envio2020home:destino', this.onDestino = (e) => {
          if (e.detail.source !== this) this.restore();
        });
        if (window.FoxTheme?.pubsub) {
          this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }

        loadLocations(this.endpoint)
          .then((data) => {
            this.locations = data;
            this.dept.innerHTML = '<option value="">Departamento</option>' +
              data.departments.map((d) => `<option value="${escapeHtml(d.code)}">${escapeHtml(d.name)}</option>`).join('');
            this.restore();
          })
          .catch(() => this.showError('No pudimos cargar las ciudades. El envío se calcula en el checkout.'));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        document.removeEventListener('envio2020home:destino', this.onDestino);
      }

      fillCities(selected = '') {
        const code = this.dept.value;
        const cities = code
          ? [...new Set(this.locations.cities.filter((c) => !c.department || c.department === code).map((c) => c.city))]
          : [];
        this.city.innerHTML = '<option value="">Ciudad</option>' +
          cities.map((c) => `<option value="${escapeHtml(c)}"${c === selected ? ' selected' : ''}>${escapeHtml(titleCase(c))}</option>`).join('');
        this.city.disabled = cities.length === 0;
      }

      save() {
        write(localStorage, STORAGE_KEY, { dept: this.dept.value, city: this.city.value });
        document.dispatchEvent(new CustomEvent('envio2020home:destino', { detail: { source: this } }));
      }

      restore() {
        const saved = read(localStorage, STORAGE_KEY);
        if (!saved?.dept || !this.locations) return;
        this.dept.value = saved.dept;
        this.fillCities(saved.city);
        this.quote();
      }

      async quote() {
        if (!this.dept.value || !this.city.value) {
          this.result.innerHTML = '';
          this.setBlocked([]);
          return;
        }
        const seq = ++this.seq;
        this.result.innerHTML = '<p class="envio-2020home__muted">Calculando envío...</p>';
        try {
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
          if (cart.item_count === 0) { this.result.innerHTML = ''; this.setBlocked([]); return; }
          const res = await fetch(`${this.endpoint}/api/shipping/quote`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ city: this.city.value, province: this.dept.value, items: cart.items }),
          });
          const data = await res.json();
          if (seq !== this.seq) return;
          this.render(data, cart);
        } catch (e) {
          this.showError('No pudimos calcular el envío. Se calculará en el checkout.');
          this.setBlocked([]);
        }
      }

      render(data, cart) {
        const blocked = (data.items || []).filter((i) => i.blocked);
        this.setBlocked(blocked, cart);

        if (data.status !== 'ok') {
          let html = `<p class="envio-2020home__error">${escapeHtml(data.message || 'No hay envío para esta ciudad.')}</p>`;
          if (blocked.length > 0) {
            html += `<ul class="envio-2020home__blocked">${blocked.map((i) => `<li>${escapeHtml(i.name)}</li>`).join('')}</ul>`;
          }
          this.result.innerHTML = html;
          return;
        }

        const rows = (data.vendors || []).map((v) => `
          <li class="envio-2020home__row">
            <span>Flete ${escapeHtml(v.vendor)}</span>
            <span${v.total_cop === 0 ? ' class="envio-2020home__free"' : ''}>${v.total_cop === 0 ? 'Gratis' : COP.format(v.total_cop)}</span>
          </li>`).join('');
        const total = data.total_cop === 0
          ? '<span class="envio-2020home__free">Gratis</span>'
          : `<span>${COP.format(data.total_cop)}</span>`;
        this.result.innerHTML = `
          <ul class="envio-2020home__rows">
            ${(data.vendors || []).length > 1 ? rows : ''}
            <li class="envio-2020home__row envio-2020home__row--total"><span>Envío a ${escapeHtml(titleCase(this.city.value))}</span>${total}</li>
          </ul>`;
      }

      showError(text) {
        this.result.innerHTML = `<p class="envio-2020home__error">${escapeHtml(text)}</p>`;
      }

      // Productos bloqueados: en rojo en el carrito y sin botón de pagar
      setBlocked(blocked, cart) {
        const variantIds = new Set(blocked.map((i) => String(i.variant_id)));
        document.querySelectorAll('.envio-2020home-blocked-item').forEach((el) => el.classList.remove('envio-2020home-blocked-item'));
        if (cart) {
          cart.items.forEach((item, index) => {
            if (!variantIds.has(String(item.variant_id))) return;
            document.querySelectorAll(`#CartItem-${index + 1}, #CartDrawer-Item-${index + 1}`)
              .forEach((el) => el.classList.add('envio-2020home-blocked-item'));
          });
        }
        const isBlocked = variantIds.size > 0;
        document.querySelectorAll('button[name="checkout"]').forEach((btn) => {
          btn.disabled = isBlocked;
          btn.title = isBlocked ? 'Quita los productos que no se envían a tu ciudad' : '';
        });
        document.querySelectorAll('.additional-checkout-buttons').forEach((el) => { el.hidden = isBlocked; });
      }
    }

    customElements.define('envio-2020home', Envio2020Home);
  })();
  } catch(e) { console.error(e); }
})();

})();
